import request from '@/utils/request'

/** 待我审批列表 category: 1=待办 2=已办 3=抄送 */
export function getFlowBeforeList(category, data) {
  return request({
    url: `/api/workflow/Engine/FlowBefore/List/${category}`,
    method: 'get',
    data
  })
}

/** 审批详情 processId 为流程实例主键 */
export function getFlowBeforeInfo(id, data) {
  return request({
    url: `/api/workflow/Engine/FlowBefore/${id}`,
    method: 'get',
    data
  })
}

/** 审批通过 operatorId 为待办列表项 id */
export function auditFlow(operatorId, data) {
  return request({
    url: `/api/workflow/Engine/FlowBefore/Audit/${operatorId}`,
    method: 'post',
    data
  })
}

/** 审批驳回 */
export function rejectFlow(operatorId, data) {
  return request({
    url: `/api/workflow/Engine/FlowBefore/Reject/${operatorId}`,
    method: 'post',
    data
  })
}
